import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable no-underscore-dangle */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Portal from '../Portal';
import { getAllowedAttributes } from '../props-filters';
import propTypeClassName from '../propTypeClassName';
import * as style from './Overlay.style';

var Overlay = function (_PureComponent) {
  _inherits(Overlay, _PureComponent);

  function Overlay() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Overlay);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Overlay.__proto__ || _Object$getPrototypeOf(Overlay)).call.apply(_ref, [this].concat(args))), _this), _this._overlayDomNode = null, _this._handleOverlayRef = function (node) {
      if (!node) return;
      _this._overlayDomNode = node;
      if (_this.props.onKeyDown) {
        _this._overlayDomNode.focus();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Overlay, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          zIndex = _props.zIndex,
          restProps = _objectWithoutProperties(_props, ['className', 'children', 'onClick', 'onKeyDown', 'zIndex']);

      var interactionProps = {
        onClick: onClick,
        onKeyDown: onKeyDown
      };
      var a11yProps = onKeyDown ? { tabIndex: 0, role: 'button' } : { role: 'presentation' };
      var allowedAttributes = getAllowedAttributes(restProps);

      return React.createElement(
        Portal,
        null,
        React.createElement(
          'div',
          { className: className, 'data-test-id': 'Overlay' },
          React.createElement(
            'div',
            _extends({}, allowedAttributes, interactionProps, a11yProps, {
              ref: this._handleOverlayRef,
              className: style.overlay,
              style: { zIndex: zIndex }
            }),
            children
          )
        )
      );
    }
  }]);

  return Overlay;
}(PureComponent);

Overlay.propTypes = {
  // TODO: implement possibility to choose type of overlay (grey with opacity or blue500, or from theme)
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   */
  className: propTypeClassName,
  /** The Overlay children */
  children: PropTypes.node,
  /** Native attribute */
  onClick: PropTypes.func,
  /** Native attribute */
  onKeyDown: PropTypes.func,

  /** zIndex passed to styles */
  zIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default Overlay;